// extracted by mini-css-extract-plugin
export default {"container":"BlogMenu_container_DQDdN","item":"BlogMenu_item_ay0mx","itemDisabled":"BlogMenu_itemDisabled_gRHcJ","icon":"BlogMenu_icon_ChKoL"};